export enum EUser {
  GET_LIST = 'user/getList',
  GET_MORE = 'user/getMoreUser',
  GET_FILTERED = 'user/getFiltered',
  GET_BY_ID = 'user/getUerById',
  DELETE = 'user/deleteById',
  BAN_FROM_APP = 'user/banUserFromApp',
  UNBAN = 'user/unbanUser',
}
